import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  DateRangeQuery,
  Error,
  GetRunResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onError?: (error: Error) => void
  onSuccess?: (response: GetRunResponse[]) => void
  children?: (response: GetRunResponse[]) => ReactElement
  shortErrorMessage?: string
  id: string
  params?: DateRangeQuery
}

const GetAiModelRunsRequest = ({
  onError,
  onSuccess,
  children,
  shortErrorMessage,
  id,
  params
}: Props) => {
  const url = `${AI_API_SERVICE}/models/${id}/runs`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetAiModelRunsRequest
